import styled from 'styled-components';

const PostalRewardsBoldText = styled.p<{ checked?: boolean }>`
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
  line-height: 1.3;
  &:first-child {
    margin-bottom: 0.25rem;
  } /* overrides a global style that applies 1rem margin to the first child of a p tag */
`;

const PostalRewardsSmallText = styled.p<{ checked?: boolean }>`
  font-size: 0.75rem;
  margin: 0;
  opacity: 0.8;
`;

export {
  PostalRewardsBoldText,
  PostalRewardsSmallText
};
